import React, { Component } from "react";
import PropTypes from "prop-types";
import { filterCsvEmployees } from "../filter-csv-employees";
import { displayActiveEmployees } from "../displays/display-active-employees";
import { displayFileFilterNotification } from "../displays/display-file-filter-notification";
import { hideTipNotification } from "../../commons/hide-tip-notification";

import DropDown from "../../../app/components/dropDown/DropDown";
import FilterSection from "../../../app/components/filterSection/FilterSection";
import FilterCsvButton from "../../../app/components/filterCsvButton/FilterCsvButton";

class EmployeesFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {},
      filteredEmployees: 0,
      csvStatus: "info",
    };
  }

  componentDidUpdate(prevProps) {
    const { employeeIds } = this.props;
    if (prevProps.employeeIds !== employeeIds) {
      this.handleTipNotification();
    }
  }

  handleTipNotification = () => {
    const { employeeIds } = this.props;
    const { filteredEmployees, csvStatus } = this.state;

    if (employeeIds.length !== filteredEmployees) {
      this.setState({ csvStatus: "warning" });
    }
    if (employeeIds.length === 0) {
      this.setState({ csvStatus: "error" });
    }

    displayFileFilterNotification({
      state: csvStatus,
      employeeIds: employeeIds.length,
      filteredEmployees,
    });
  };

  filterCsvList = (values) => {
    const { filters } = this.state;
    const employeeCsvFilter = (employee) => {
      return (
        values.includes(employee.internalId) ||
        values.includes(employee.email) ||
        values.includes(employee.legalId)
      );
    };
    const filter = { ...filters, csv: employeeCsvFilter };

    this.reloadList({ filtersEmployees: filter, selectEmployees: true });
    this.setState({ csvStatus: "success", filteredEmployees: values.length });
  };

  filterItemsList = ({ property, value = [] }) => {
    const { filters } = this.state;

    const employeePropertyFilter = (employee) =>
      !value.length || value.includes(employee[property]);
    const currentFilters = {
      ...filters,
      [property]: employeePropertyFilter,
    };

    this.reloadList({ filtersEmployees: currentFilters });
  };

  reloadList = ({ filtersEmployees, selectEmployees = false }) => {
    const filters = Object.values(filtersEmployees);
    displayActiveEmployees({
      employeeFilter: (employee) => filters.every((filter) => filter(employee)),
      selectAll: selectEmployees,
    });

    this.setState({ filters: filtersEmployees });
  };

  clearFileFilter = () => {
    hideTipNotification("notification-file-filter");
    this.setState({ csvStatus: "info" });
    this.filterItemsList({ property: "csv" });
  };

  async handleLoadFile(e) {
    const filename = e.target.files[0];
    const { isInvalid, result } = await filterCsvEmployees({ filename });
    if (isInvalid) {
      this.setState({ csvStatus: "error" });
    }
    this.filterCsvList(result);
  }

  render() {
    const { availableFilters } = this.props;
    const { csvStatus } = this.state;
    return (
      <>
        <FilterSection>
          {availableFilters.map((filter) =>
            filter.items.length > 1 ? (
              <li key={filter.property} className="filter-item">
                <DropDown
                  multiSelect
                  title={filter.title}
                  items={filter.items}
                  changeSelected={(item) =>
                    this.filterItemsList({
                      property: `${filter.property}`,
                      value: item,
                    })
                  }
                />
              </li>
            ) : null
          )}
          <li className="filter-item">
            <FilterCsvButton
              status={csvStatus}
              uploadFile={(file) => this.handleLoadFile(file)}
              clearFilter={this.clearFileFilter}
            />
          </li>
        </FilterSection>
        <div id="notification-file-filter" />
      </>
    );
  }
}

EmployeesFilter.defaultProps = {};

EmployeesFilter.propTypes = {
  availableFilters: PropTypes.array.isRequired,
  employeeIds: PropTypes.array.isRequired,
};

export default EmployeesFilter;
